import { Context, type Cause, type Effect, Layer, type Scope } from "effect";
import type { MarkdownCopyFailure, MarkdownCopySelection } from "./markdown-copy-model.ts";

export class MarkdownCopyIo extends Context.Service<MarkdownCopyIo, {
  readonly select: (root: HTMLElement, target: EventTarget | null) => Effect.Effect<MarkdownCopySelection | undefined, MarkdownCopyFailure>;
  readonly writeText: (text: string) => Effect.Effect<unknown, MarkdownCopyFailure>;
  readonly feedback: (selection: MarkdownCopySelection, copied: boolean) => Effect.Effect<unknown, MarkdownCopyFailure>;
}>()("workerstation/frontend/MarkdownCopyIo") {}
export const MarkdownCopyIoTest = (io: typeof MarkdownCopyIo.Service) => Layer.succeed(MarkdownCopyIo, io);
export interface MarkdownCopySession { readonly copy: (root: HTMLElement, target: EventTarget | null) => Effect.Effect<void> }
export class MarkdownCopies extends Context.Service<MarkdownCopies, {
  readonly open: Effect.Effect<MarkdownCopySession, never, Scope.Scope>;
  readonly failures: Effect.Effect<readonly Cause.Cause<MarkdownCopyFailure>[]>;
}>()("workerstation/frontend/MarkdownCopies") {}
